const { accountNo } = require('./account-no')
const { splitByThousand } = require('./split-by-thousand')

module.exports = {
  accountNo,
  splitByThousand
}
